import { IOperatorInstructionModel } from "../../interfaces/OperatorInstruction/IOperatorInstructionModel";
import {
  IWarningModalModel,
  WarningModalModel,
} from "../../interfaces/WarnigModal/IWarningModalModel";
import { IPayloadWrapper } from "./PayloadWrapper";

export const SET_CURRENT_INSTRUCTION = "automatpacken/instruction/SET_CURRENT_INSTRUCTION";
export const SET_PREVIOUS_INSTRUCTION = "automatpacken/instruction/SET_PREVIOUS_INSTRUCTION";
export const CLEAR_INSTRUCTIONS = "automatpacken/instruction/CLEAR_INSTRUCTIONS";
export const TOGGLE_SHOW_INSTRUCTION = "automatpacken/instruction/TOGGLE_SHOW_INSTRUCTION";
export const SET_WARNING_MODAL = "automatpacken/instruction/SET_WARNING_MODAL";
export const CLEAR_WARNING_MODAL = "automatpacken/instruction/CLEAR_WARNING_MODAL";

interface SetCurrentInstruction {
  type: typeof SET_CURRENT_INSTRUCTION;
  payload: IOperatorInstructionModel;
  meta: () => void;
}

interface SetPreviousInstruction {
  type: typeof SET_PREVIOUS_INSTRUCTION;
  payload: IOperatorInstructionModel;
}

interface ClearInstructions {
  type: typeof CLEAR_INSTRUCTIONS;
}

interface ToggleShowInstruction {
  type: typeof TOGGLE_SHOW_INSTRUCTION;
  payload: IPayloadWrapper<boolean>;
}

interface SetWarningModal {
  type: typeof SET_WARNING_MODAL;
  payload: IWarningModalModel;
  meta: (message: string, error: string, header: string) => void;
}

interface ClearWarningModal {
  type: typeof CLEAR_WARNING_MODAL;
}

export interface InstructionState {
  currentInstruction: IOperatorInstructionModel | null;
  previousInstruction: IOperatorInstructionModel | null;
  currentInstructionID: number;
  previousInstructionID: number;
  visible: boolean;
  warningModal: WarningModalModel;
  showWarningModal: boolean;
}

export type InstructionActionTypes =
  | SetCurrentInstruction
  | SetPreviousInstruction
  | ClearInstructions
  | ToggleShowInstruction
  | SetWarningModal
  | ClearWarningModal;
